/** @format */

import type { BaseResponse } from '@/utils';
import { request } from '@/utils';

// 查询部门列表
export function listDept(query: any) {
	return request<BaseResponse<any>>({
		url: '/system/dept/list',
		method: 'get',
		params: query,
	});
}

// 查询部门列表（排除节点）
export function listDeptExcludeChild(deptId) {
	return request<BaseResponse<any>>(
		{
			url: `/system/dept/list/exclude/${deptId}`,
			method: 'get',
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 查询部门详细
export function getDept(deptId) {
	return request<BaseResponse<any>>(
		{
			url: `/system/dept/${deptId}`,
			method: 'get',
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 查询部门下拉树结构
export function treeselect() {
	return request<BaseResponse<any>>(
		{
			url: '/system/dept/treeselect',
			method: 'get',
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 根据角色ID查询部门树结构
export function roleDeptTreeselect(roleId) {
	return request<BaseResponse<any>>(
		{
			url: `/system/dept/roleDeptTreeselect/${roleId}`,
			method: 'get',
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 新增部门
export function addDept(data) {
	return request<BaseResponse<any>>(
		{
			url: '/system/dept',
			method: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 修改部门
export function updateDept(data) {
	return request<BaseResponse<any>>(
		{
			url: '/system/dept',
			method: 'put',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 删除部门
export function delDept(deptId) {
	return request<BaseResponse<any>>(
		{
			url: `/system/dept/${deptId}`,
			method: 'delete',
		},
		{
			isGetDataDirectly: false,
		},
	);
}
